module.exports = __webpack_public_path__ + "img/Bear41.3c727683.jpg";